import bigFight from "../assets/screenshots/big-fight.jpg";
import fall from "../assets/screenshots/fall.jpg";
import farming from "../assets/screenshots/farming.jpg";
import fight from "../assets/screenshots/fight.jpg";
import help from "../assets/screenshots/help.jpg";

export default [help, fall, fight, farming, bigFight];
